import React from 'react';
import { useSelector } from 'react-redux';
import { checkCustomPackage } from '@src/services/package';
import Text from '../Shared/Text';

const ConcurrentDevicesFeature = ({ pkg }) => {
  const optionsSelected = useSelector(
    (state) => state.packages.optionsSelected,
  );

  const isCustomPackage = checkCustomPackage({
    type: pkg.type,
    level: pkg.level,
  });
  if (isCustomPackage) {
    const minDevices = pkg?.customResource?.devices?.min || 0;
    const totalDevices = minDevices + optionsSelected?.devices;
    return <Text key={pkg.code} text={totalDevices} />;
  }

  return <Text key={pkg.code} text={pkg?.device} />;
};

const concurrentDevicesFeatures = ({ packages }) =>
  packages.map((pkg) => <ConcurrentDevicesFeature key={pkg.code} pkg={pkg} />);

export default concurrentDevicesFeatures;
